export default __webpack_public_path__ + "static/media/wifi-slash.e2dc420e.svg";